export class StackUtil<T> {
  items: T[] = [];
  constructor() {
    this.items = [];
  }
  push(item: T) {
    this.items.push(item);
  }
  peek() {
    return this.items[this.items.length - 1];
  }
  pop() {
    if (this.isEmpty()) return false;
    this.items.pop();
    return true;
  }

  isEmpty() {
    return this.items.length === 0;
  }

  size() {
    return this.items.length;
  }
}
